import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';

@Injectable({
  providedIn: 'root',
})
export class RolService {
  analystRas = false;
  managerRas = false;
  complianceOfficerRas = false;
  supervisorDet = false;
  gerenteDet = false;

  permisos = [];

  baseUrl = `${this.env.URL_API}/rol`;
  constructor(private http: HttpClient, private env: EnvService) { }

  get showRas() {
    return this.analystRas || this.managerRas || this.complianceOfficerRas;
  }

  async rolesAvailables() {
    return await new Promise((resolve) => {
      if (sessionStorage.getItem('id_rol') === null) {
        resolve(false);
      }

      if (this.permisos.length > 0) {
        this.setValues();
        resolve(true);
      } else {
        this.http
          .get(
            `${this.env.URL_API}/rol_permiso/${sessionStorage.getItem(
              'id_rol'
            )}`
          )
          .subscribe((response: any) => {
            const permisos = [];
            for (const i in response.payload.data) {
              // linted by ga, added if conditional and changed all let variables to const
              if (response.payload.data.hasOwnProperty(i)) {
                const rol = response.payload.data[i];
                const nombrePermiso = rol.nombre;
                permisos.push(nombrePermiso);
              }
            }
            this.permisos = permisos;

            this.setValues();
            resolve(true);
          });
      }
    });
  }

  setValues() {
    this.analystRas = false;
    this.managerRas = false;
    this.complianceOfficerRas = false;

    // for (let i in this.permisos) {
    //   this.permisos[i].indexOf('analystRas') !== -1
    //     ? (this.analystRas = true)
    //     : null;
    //   this.permisos[i].indexOf('managerRas') !== -1
    //     ? (this.managerRas = true)
    //     : null;
    //   this.permisos[i].indexOf('complianceOfficerRas') !== -1
    //     ? (this.complianceOfficerRas = true)
    //     : null;
    //   this.permisos[i].indexOf('Supervisor Gestión de Fraudes') !== -1
    //     ? (this.supervisorDet = true)
    //     : null;
    //   this.permisos[i].indexOf('Gerente Gestión de Fraudes') !== -1
    //     ? (this.gerenteDet = true)
    //     : null;
    // }

// linted by GA: 
    for (const i in this.permisos) {
      if (this.permisos.hasOwnProperty(i)) {
        this.analystRas = this.permisos[i].indexOf('analystRas') !== -1;
        this.managerRas = this.permisos[i].indexOf('managerRas') !== -1;
        this.complianceOfficerRas = this.permisos[i].indexOf('complianceOfficerRas') !== -1;
        this.supervisorDet = this.permisos[i].indexOf('Supervisor Gestión de Fraudes') !== -1;
        this.gerenteDet = this.permisos[i].indexOf('Gerente Gestión de Fraudes') !== -1;
      }
    }
  }
}
